module.exports = __webpack_public_path__ + "static/logotype-white-37eba8cb8301d1f1615cdf182f7c3357.png";